import { useCallback, useEffect } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { getOpenDockCarrierId } from '../../use-cases/getOpenDockCarrierId'

export function useGetOpenDockCarrierId(shipmentUUID: string, enabled: boolean) {
  const { call, result, status, error } = useAsync(getOpenDockCarrierId)
  const abortController = useAbortController()

  const fetchOpenDockCarrierId = useCallback(
    (shipmentUUID: string) =>
      call({
        shipmentUUID,
        config: abortController,
      }),
    [call, abortController]
  )

  useEffect(() => {
    if (enabled) {
      call({
        shipmentUUID,
        config: {
          signal: abortController.signal,
        },
      })
    }
  }, [abortController, call, enabled, shipmentUUID])

  return {
    openDockCarrierId: result?.id,
    isOpenDockCarrierActive: result?.isActive ?? false,
    status,
    error,
    fetchOpenDockCarrierId,
  }
}
